export default __webpack_public_path__ + "static/media/closeModal.e248c4b1.svg";